module.exports = __webpack_public_path__ + "static/media/2.161bfd0d.jpg";